const state = {
};

const getters = {
};

const actions = {
	LoadStoragePaths({ commit }) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('whm_import.get_entities_and_storage_paths');
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	TestCpanelBackup({ commit }, request_data) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('whm_import.get_cpanel_backup_test_result');
			this._vm.$axios.post(r, request_data)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	FetchCpanelAccounts({ commit }, request_data) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('whm_import.fetch_cpanel_accounts');
			this._vm.$axios.post(r, request_data)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetStorageFilesListingResult({ commit }, request_data) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('whm_import.get_storage_files_listing_result');
			this._vm.$axios.post(r, request_data)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetStorageFiles({ commit }, location_data) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('whm_import.get_storage_files');
			this._vm.$axios.post(r, location_data)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	RestoreCpanelAccounts({ commit }, request_data) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('whm_import.restore_cpanel_accounts');
			this._vm.$axios.post(r, request_data)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetEntityDatabaseSystems({ commit }, request_data) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('whm_import.get_entity_database_systems');
			this._vm.$axios.post(r, request_data)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	CheckRestoreAccountStatus({ commit }, request_data) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('whm_import.check_restore_account_status');
			this._vm.$axios.post(r, request_data)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	SendActivationEmails({ commit }, request_data) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('whm_import.send_activation_emails');
			this._vm.$axios.post(r, request_data)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	}
};


const mutations = {
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
